import React from "react"
import { MdAdd, MdDeleteOutline } from "react-icons/md"
import Button from "../Form/Button"
import Input from "../Form/Input"
import Select from "../Form/Select"
import styles from "./leadFilters.module.css"

const MAX_FILTERS = 10

const utmFieldOptions = [
    { id: "source", value: "UTM Source" },
    { id: "medium", value: "UTM Medium" },
    { id: "campaign", value: "UTM Campaign" },
    { id: "content", value: "UTM Content" },
    { id: "term", value: "UTM Term" },
    { id: "url", value: "UTM URL" },
]

const utmOperatorOptions = [
    { id: "equals", value: "É igual a" },
    { id: "contains", value: "Contém" },
    { id: "starts_with", value: "Começa com" },
    { id: "is_set", value: "Está preenchido" },
    { id: "is_not_set", value: "Não está preenchido" },
]

const UtmFilters = ({ value = [], onChange = () => { } }) => {
    const updateFilter = (index, data) => {
        onChange(value.map((filter, filterIndex) => filterIndex === index ? { ...filter, ...data } : filter))
    }

    const addFilter = () => {
        if (value.length >= MAX_FILTERS) return
        onChange([...value, { field: "", operator: "equals", value: "" }])
    }

    const removeFilter = index => onChange(value.filter((_, filterIndex) => filterIndex !== index))

    return (
        <div className={styles.additionalFilters}>
            {value.map((filter, index) => {
                const presenceOperator = ["is_set", "is_not_set"].includes(filter.operator)
                const fieldLabel = utmFieldOptions.find(option => option.id === filter.field)?.value || "UTM"

                return (
                    <div className={styles.additionalFilter} key={`${filter.field || "new"}-${index}`}>
                        <div className={styles.additionalFilterNumber}>{index + 1}</div>
                        <div className={styles.additionalFilterFields}>
                            <Select name="Campo UTM" placeholder="Selecione um campo" options={utmFieldOptions} selected={filter.field || ""} onChange={field => updateFilter(index, { field, value: "" })} multiple={false} />
                            <Select name="Condição" placeholder="Selecione uma condição" options={utmOperatorOptions} selected={filter.operator || "equals"} onChange={operator => updateFilter(index, { operator, value: "" })} multiple={false} />
                            {!presenceOperator &&
                                <Input type={filter.field === "url" ? "url" : "text"} placeholder={`Valor de ${fieldLabel}`} value={filter.value || ""} onChange={event => updateFilter(index, { value: event.target.value })} />
                            }
                        </div>
                        <Button type="button" className={styles.removeFilter} onClick={() => removeFilter(index)} aria-label="Remover filtro UTM">
                            <MdDeleteOutline />
                        </Button>
                    </div>
                )
            })}
            <Button variant="secondary" type="button" onClick={addFilter} disabled={value.length >= MAX_FILTERS}>
                <MdAdd /> Adicionar condição UTM
            </Button>
        </div>
    )
}

export { utmFieldOptions, utmOperatorOptions }
export default UtmFilters
